var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 4.7625 4.7625",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-69.092 -111.98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26183 0 0 .26183 62.811 -88.316)",
    fill: "none",
    stroke: "#07234a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.168 776.43v3.1484c0 0.87109-0.70312 1.5742-1.5742 1.5742h-11.02c-0.87109 0-1.5742-0.70313-1.5742-1.5742v-3.1484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.148 772.5 3.9375 3.9375 3.9336-3.9375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.086 776.43v-9.4453"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.f89150286a49f3c89d507efe3c2c5d40.svg";
export { ForwardRef as ReactComponent };